export default __webpack_public_path__ + "static/media/downloadAll.d7268fc8.svg";